import React, { useContext, useMemo, useState } from 'react'
import { RendererContext } from '@/components/FURenderkit'
import SpinLoading from '@/components/Common/SpinLoading'
import { SceneContext } from '@/components/RenderComp/Scene'
import { AvatarContext } from '@/components/RenderComp/Avatar'
import FUIcon from '@/components/Common/FUIcon'
import { RESOURCE_MANAGER } from '@/config'

const ColorBundle = (props) => {
    const {
        item,
        selectedDressupPart,
        setSelectedDressupPart,
        setSelectedDressupType,
        selectedTypeInCurrentPart,
        setSelectedTypeInCurrentPart,
    } = props
    const { avatar } = useContext(AvatarContext)
    function handleColorSelect(color) {
        if (!avatar) return
        const oldColor = avatar.getColor(selectedTypeInCurrentPart.name)
        colorHandler({
            type: selectedDressupPart,
            name: selectedTypeInCurrentPart.name,
            value: color
        })
        RESOURCE_MANAGER.recorder.record({
            type: 'color',
            oldValue: {
                type: selectedDressupPart,
                name: selectedTypeInCurrentPart.name,
                value: oldColor
            },
            newValue: {
                type: selectedDressupPart,
                name: selectedTypeInCurrentPart.name,
                value: color
            },
            handler: colorHandler
        })
    }

    function colorHandler({ type, name, value: color }) {
        if (!avatar) return
        avatar.setColor(name, color);
        setSelectedDressupPart(type)
        setSelectedDressupType(name)
        setTimeout(() => {
            selectedTypeInCurrentPart.selected = color.join("#")
            setSelectedTypeInCurrentPart({ ...selectedTypeInCurrentPart })
        }, 0)
    }
    let colorName = ''
    try {
        colorName = avatar?.getColor(
            selectedTypeInCurrentPart.name
        ).join('#') === item.join('#')
            ? 'slices/icon_tab2_selected@2x.png'
            : ''
    } catch (e) {
        console.error(e)
    }
    return (
        <FUIcon
            key={`rgb(${item[0]},${item[1]},${item[2]})`}
            className="color-component"
            size="40px"
            name={colorName}
            style={{
                'backgroundColor': `rgb(${item[0]},${item[1]},${item[2]})`,
            }}
            onClick={() => handleColorSelect(item)}
        />
    )
}

export default ColorBundle
